import { motion } from "framer-motion";
import { PiggyBank, TrendingUp, ShieldCheck, Leaf } from "lucide-react";
import { IMAGES } from "@/lib/constants";

const EASE = [0.16, 1, 0.3, 1];

const CHAPTERS = [
  {
    num: "01",
    icon: PiggyBank,
    title: "Economia drástica",
    text: "Reduza sua conta de luz em até 95% desde o primeiro mês. O dinheiro que ia para a concessionária fica no seu bolso.",
    span: "lg:col-span-2",
    dark: true,
  },
  {
    num: "02",
    icon: TrendingUp,
    title: "Imóvel valorizado",
    text: "Imóveis com energia solar valem mais e vendem mais rápido. Valorização imediata de mercado.",
    span: "",
    dark: false,
  },
  {
    num: "03",
    icon: ShieldCheck,
    title: "Independência energética",
    text: "Blindagem contra os aumentos de tarifa. Você gera a própria energia por mais de 25 anos.",
    span: "",
    dark: false,
    image: IMAGES.panelsCloseUp,
  },
  {
    num: "04",
    icon: Leaf,
    title: "Sustentabilidade & sol da Bahia",
    text: "Um dos maiores índices de irradiação solar do Brasil. Energia limpa, renovável e orgulhosamente baiana.",
    span: "lg:col-span-2",
    dark: true,
  },
];

export const Manifesto = () => (
  <section
    id="beneficios"
    data-testid="manifesto-chapters-section"
    className="relative py-24 lg:py-32 bg-[#FAFAF9]"
  >
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <motion.div
        initial={{ opacity: 0, y: 32 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9, ease: EASE }}
        className="max-w-3xl"
      >
        <p className="text-xs font-bold uppercase tracking-[0.22em] text-amber-500 mb-4">
          Manifesto HB Solar
        </p>
        <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight leading-tight text-[#0B192C]">
          Por que milhares de baianos estão trocando a conta de luz{" "}
          <span className="text-outline font-extrabold">pelo sol</span>
        </h2>
      </motion.div>

      <div className="mt-14 grid lg:grid-cols-3 gap-5">
        {CHAPTERS.map((ch, i) => (
          <motion.article
            key={ch.num}
            initial={{ opacity: 0, y: 44 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.8, delay: i * 0.1, ease: EASE }}
            className={`group relative overflow-hidden rounded-3xl p-8 sm:p-10 border transition-shadow duration-500 hover:shadow-[0_30px_60px_rgba(11,25,44,0.12)] ${ch.span} ${
              ch.dark
                ? "bg-[#0B192C] border-white/10 text-white"
                : "bg-white border-slate-200/80 text-[#0B192C]"
            }`}
          >
            {ch.image && (
              <>
                <img
                  src={ch.image}
                  alt=""
                  className="absolute inset-0 h-full w-full object-cover opacity-90 transition-transform duration-700 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0B192C]/95 via-[#0B192C]/50 to-[#0B192C]/20" />
              </>
            )}
            <div className="relative">
              <div className="flex items-start justify-between">
                <span
                  className={`font-mono text-sm font-semibold tracking-widest ${
                    ch.dark || ch.image ? "text-amber-400" : "text-amber-500"
                  }`}
                >
                  /{ch.num}
                </span>
                <span
                  className={`flex h-12 w-12 items-center justify-center rounded-2xl transition-transform duration-500 group-hover:-rotate-12 group-hover:scale-110 ${
                    ch.dark || ch.image
                      ? "bg-amber-400/15 text-amber-400"
                      : "bg-amber-100 text-amber-600"
                  }`}
                >
                  <ch.icon className="h-6 w-6" strokeWidth={2} />
                </span>
              </div>
              <h3
                className={`mt-16 font-display text-xl sm:text-2xl font-semibold tracking-tight ${
                  ch.image ? "text-white" : ""
                }`}
              >
                {ch.title}
              </h3>
              <p
                className={`mt-3 text-base leading-relaxed ${
                  ch.dark || ch.image ? "text-slate-300" : "text-slate-600"
                }`}
              >
                {ch.text}
              </p>
            </div>
          </motion.article>
        ))}
      </div>
    </div>
  </section>
);
